<template>
  <v-snackbar
    v-model="showSnackbar"
    bottom
    right
    :color="snackbar.color"
    :timeout="timeout"
    class="snackbar"
  >
    {{ snackbar.text }}
    <v-btn
      dark
      text
      @click="showSnackbar = false"
    >
      Close
    </v-btn>
  </v-snackbar>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  export default {
    data() {
      return {
        showSnackbar: true,
        color: 'green',
        timeout: 2000,
        mode: ''
      }
    },
    methods: mapActions(['resetSnackbar']),
    computed: mapGetters(['snackbar']),
    created() {
      setTimeout(() => {
        this.resetSnackbar();
      }, this.timeout);
    }
  }
</script>

<style scoped>
.snackbar {
  z-index: 10000;
}
</style>